import { useState, useEffect } from 'react';
import { isEqual, omit } from 'lodash';
import { v4 as generateBriefId } from 'uuid';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import { PAGE, SESSION_STATE_KEY } from '../../constants';

const { store: mixpanelStore, getFilterAppliedReporter } =
    marketplaceIntegration;

const getCachedState = () => {
    const rawState = window?.sessionStorage?.getItem(SESSION_STATE_KEY);

    return rawState ? JSON.parse(rawState) : null;
};

const briefDefaultData = {
    brandName: '',
    slogan: '',
    industries: [],
    keywords: [],
};

export const useBriefData = () => {
    const cachedState = getCachedState();
    const pageByCache = cachedState?.page;
    const pageByAllocation = PAGE.BRIEF;

    const [page, setPage] = useState(pageByCache || pageByAllocation);
    const [briefData, setBrief] = useState(
        cachedState?.briefData || briefDefaultData
    );
    const [briefId, setBriefId] = useState(
        cachedState?.briefId || generateBriefId()
    );

    const setBriefData = (update, reportingOptions = {}) => {
        setBrief((briefData) => {
            const reportFilterApplied = getFilterAppliedReporter(briefData);
            const newBriefData = { ...briefData, ...update };
            if (
                !isEqual(
                    omit(briefData, ['brandName', 'slogan']),
                    omit(newBriefData, ['brandName', 'slogan'])
                )
            ) {
                setBriefId(generateBriefId());
            }

            reportFilterApplied(
                update,
                reportingOptions.location,
                !!reportingOptions.viaCarousel
            );

            return newBriefData;
        });
    };

    useEffect(() => {
        mixpanelStore.brief.setData(briefData);
    }, [briefData]);

    return {
        briefData,
        briefId,
        setBriefData,
        page,
        setPage,
    };
};
